<template>
	<div class="baseCard">
		<Lunbo node="gywm_lbt"></Lunbo>

		<div class="volMain">
			<tabLan :tabList="tabList" @setIndex="tabMenu"></tabLan>
			<div class="vlContent" v-show="index == 0">
				<div class="aboutUs">
					<p class="aboutTitle">{{ dataFirst.title }}</p>
					<div class="aboutHtml" v-html="dataFirst.text"></div>
				</div>
			</div>
			<div class="vlContent" v-show="index == 1">
				<div class="aboutUs">
					<p class="aboutTitle">{{ dataSecond.title }}</p>
					<div class="aboutHtml" v-html="dataSecond.text"></div>
				</div>
			</div>
			<div class="videoContent" v-show="index == 2">
				<div class="aboutUs">
					<p class="aboutTitle">人员信息</p>
					<div style="width: 100%;display: flex; flex-direction: column;align-items: center;">
						<div style="width: 100%;display: flex;align-items: center; justify-content: center;padding: 30px 0;border-bottom: 2px solid rgb(154,154,154);">
							<div style="font-size: 22px;font-weight: bold;margin-right: 50px;width: 100px;text-align: right;">理事长</div>
							<div class="newManList">
								<div style="font-size: 18px;margin: 0 25px;" v-for="item of manList1">
									<div style="width: 140px;height: 180px;display: flex;align-items: center;justify-content: center;border: 1px solid rgb(205,205,205);">
										<img :src="item.smallImage" style="width: 120px;height: 160px;" />
									</div>
									<div style="width: 140px;text-align: center;margin: 10px 0;">{{ item.name }}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 100%;display: flex; flex-direction: column;align-items: center;">
						<div style="width: 100%;display: flex;align-items: center; justify-content: center;padding: 30px 0;border-bottom: 2px solid rgb(154,154,154);">
							<div style="font-size: 22px;font-weight: bold;margin-right: 50px;width: 100px;text-align: right;">副理事长</div>
							<div class="newManList">
								<div style="font-size: 18px;margin: 0 25px;" v-for="item of manList2">
									<div style="width: 140px;height: 180px;display: flex;align-items: center;justify-content: center;border: 1px solid rgb(205,205,205);">
										<img :src="item.smallImage" style="width: 120px;height: 160px;" />
									</div>
									<div style="width: 140px;text-align: center;margin: 10px 0;">{{ item.name }}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 100%;display: flex; flex-direction: column;align-items: center;">
						<div style="width: 100%;display: flex;align-items: center; justify-content: center;padding: 30px 0;border-bottom: 2px solid rgb(154,154,154);">
							<div style="font-size: 22px;font-weight: bold;margin-right: 50px;width: 100px;text-align: right;">理事</div>
							<div class="newManList">
								<div style="font-size: 18px;margin: 0 25px;" v-for="item of manList3">
									<div style="width: 140px;height: 180px;display: flex;align-items: center;justify-content: center;border: 1px solid rgb(205,205,205);">
										<img :src="item.smallImage" style="width: 120px;height: 160px;" />
									</div>
									<div style="width: 140px;text-align: center;margin: 10px 0;">{{ item.name }}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 100%;display: flex; flex-direction: column;align-items: center;">
						<div style="width: 100%;display: flex;align-items: center; justify-content: center;padding: 30px 0;border-bottom: 2px solid rgb(154,154,154);">
							<div style="font-size: 22px;font-weight: bold;margin-right: 50px;width: 100px;text-align: right;">秘书长</div>
							<div class="newManList">
								<div style="font-size: 18px;margin: 0 25px;" v-for="item of manList4">
									<div style="width: 140px;height: 180px;display: flex;align-items: center;justify-content: center;border: 1px solid rgb(205,205,205);">
										<img :src="item.smallImage" style="width: 120px;height: 160px;" />
									</div>
									<div style="width: 140px;text-align: center;margin: 10px 0;">{{ item.name }}</div>
								</div>
							</div>
						</div>
					</div>
					<div style="width: 100%;display: flex; flex-direction: column;align-items: center;">
						<div style="width: 100%;display: flex;align-items: center; justify-content: center;padding: 30px 0;border-bottom: 2px solid rgb(154,154,154);">
							<div style="font-size: 22px;font-weight: bold;margin-right: 50px;width: 100px;text-align: right;">监事</div>
							<div class="newManList">
								<div style="font-size: 18px;margin: 0 25px;" v-for="item of manList5">
									<div style="width: 140px;height: 180px;display: flex;align-items: center;justify-content: center;border: 1px solid rgb(205,205,205);">
										<img :src="item.smallImage" style="width: 120px;height: 160px;" />
									</div>
									<div style="width: 140px;text-align: center;margin: 10px 0;">{{ item.name }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="videoContent" v-show="index == 3">
				<div class="aboutUs">
					<p class="aboutTitle">{{ dataForst.title }}</p>
					<div class="aboutHtml" v-html="dataForst.text"></div>
				</div>
			</div>
			<div class="videoContent" v-show="index == 4">
				<div class="aboutUs">
					<p class="aboutTitle">{{ dataFive.title }}</p>
					<div class="aboutHtml" v-html="dataFive.text"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import apiUrls from '@api';
import tabLan from '@components/tabLan';
import Lunbo from '@components/Lunbo';
export default {
	data() {
		return {
			tabList: [
				{
					text: '机构简介'
				},
				{
					text: '组织架构'
				},
				{
					text: '人员信息'
				},
				{
					text: '获奖信息'
				},
				{
					text: '联系我们'
				}
			],
			index: 0,
			dataFirst: [],
			dataSecond: [],
			dataThree: [],
			dataForst: [],
			dataFive: [],
			page: 1,
			size: 15,
			total: 0,
			serveData: [],
			manList1: [],
			manList2: [],
			manList3: [],
			manList4: [],
			manList5: []
		};
	},

	components: {
		tabLan,
		Lunbo
	},

	mounted() {
		this.getDataFirst();
		this.getDataSecond();
		this.getDataThree();
		this.getDataForst();
		this.getDataFive();
	},

	methods: {
		getDataFirst() {
			apiUrls.getNode({ node: 'gywm_jgjj' }).then(res => {
				this.dataFirst = res.results.data;
			});
		},
		getDataSecond() {
			apiUrls.getNode({ node: 'gywm_zzjg' }).then(res => {
				this.dataSecond = res.results.data;
			});
		},
		getDataThree() {
			apiUrls.getList({ node: 'gywm_ryxx', search_EQ_p0: '1', size: 100 }).then(res => {
				console.log(res.results.data);
				this.manList1 = res.results.data;
			});
			apiUrls.getList({ node: 'gywm_ryxx', search_EQ_p0: '2', size: 100 }).then(res => {
				console.log(res.results.data);
				this.manList2 = res.results.data;
			});
			apiUrls.getList({ node: 'gywm_ryxx', search_EQ_p0: '3', size: 100 }).then(res => {
				console.log(res.results.data);
				this.manList3 = res.results.data;
			});
			apiUrls.getList({ node: 'gywm_ryxx', search_EQ_p0: '4', size: 100 }).then(res => {
				console.log(res.results.data);
				this.manList4 = res.results.data;
			});
			apiUrls.getList({ node: 'gywm_ryxx', search_EQ_p0: '5', size: 100 }).then(res => {
				console.log(res.results.data);
				this.manList5 = res.results.data;
			});
		},
		getDataForst() {
			apiUrls.getNode({ node: 'gywm_hjxx' }).then(res => {
				this.dataForst = res.results.data;
			});
		},
		getDataFive() {
			apiUrls.getNode({ node: 'gywm_lxwm' }).then(res => {
				this.dataFive = res.results.data;
				console.log('联系我们', this.dataFive);
			});
		},
		changePage(val) {
			this.page = val;
		},
		tabMenu(index) {
			this.page = 0;
			this.size = 15;
			this.total = 0;
			this.index = index;
		}
	}
};
</script>
<style lang="less" scoped>
.newManList {
	width: 600px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	&:after {
		content: '';
		/*这个宽度和子元素宽度一致*/
		width: 190px;
	}
}
.aboutUs {
	width: 100%;
	border: 1px solid #d8d8d8;
	padding: 20px;
	text-align: center;
	.aboutTitle {
		font-size: 18px;
		font-family: 'MicrosoftYaHeiUI-Bold', 'MicrosoftYaHeiUI';
		font-weight: bold;
		color: #333333;
		padding-bottom: 20px;
		border-bottom: 1px dotted #d8d8d8;
	}
	.message {
		width: 100%;
		padding: 2% 8%;
		height: 100%;
		display: grid;
		margin: auto;
		grid-template-columns: repeat(auto-fill, 240px);
		.people-message {
			margin: auto;
			width: 226px;
			height: 229px;
			margin-bottom: 15px;
			position: relative;
			z-index: 1;
			display: inline-block;
			overflow: hidden;
			text-align: center;
			cursor: pointer;
			img {
				width: 100%;
				height: 100%;
				opacity: 1;
				transition: opacity 0.35s, transform 0.35s;
				float: left;
			}
			.box2 {
				width: 100%;
				height: 100%;
				padding: 15px;
				position: absolute;
				box-sizing: border-box;
			}
		}
		.people-message:hover img {
			opacity: 1;
		}
		.people-message h3 {
			margin-top: 20%;
			transition: transform 0.35s;
			transform: translate3d(0, 20px, 0);
			opacity: 0;
			color: #fff;
			font-size: 16px;
		}
		.people-message p {
			margin: 10px 0 0;
			padding: 15px;
			border: 1px solid #fff;
			opacity: 0;
			transition: opacity 0.35s, transform 0.35s;
			transform: translate3d(0, 20px, 0) scale(1.1);
			color: #fff;
		}
		.people-message:hover h3 {
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}
		.people-message:hover p {
			opacity: 1;
			transform: translate3d(0, 0, 0) scale(1);
		}
	}
	.message-hj {
		width: 100%;
		padding: 2% 8%;
		display: grid;
		margin: auto;
		grid-template-columns: repeat(auto-fill, 320px);
		.people-message-hj {
			width: 322px;
			height: 100%;
			img {
				width: 100%;
				height: 169px;
			}
			div {
				width: 100%;
			}
			span {
				width: 100%;
			}
		}
	}
	.aboutHtml {
		width: 100%;
	}
}
</style>
